import { render } from "./EditBankDetailsPage.vue?vue&type=template&id=6ed20629"
import script from "./EditBankDetailsPage.vue?vue&type=script&lang=js"
export * from "./EditBankDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__